import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    subscriptionTypeList: [],
    rollList: [],
    platformList:[]
}

const commonListSlice = createSlice({
    name: "commonList",
    initialState,
    reducers: {
        setSubscriptionTypeList(state, action){
            state.subscriptionTypeList = action?.payload?.subscriptionTypeList || [];
        },
        setRollList(state, action){
            state.rollList = action?.payload?.rollList || [];
        },
        clearSubscriptionTypeList(action, state) {
            return initialState
        },
        setPlatformList(state, action){
            state.platformList = action?.payload?.platformList || [];
        },
    }

})


export const {setSubscriptionTypeList, clearSubscriptionTypeList, setRollList, setPlatformList } = commonListSlice.actions

export const commonListActions = commonListSlice.actions;

export default commonListSlice
